import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatAudioTime } from '@src/utils/time';
import { MAX_DURATION, MIN_DURATION } from '@src/constants/instantVoiceCloning';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { COLOR } from '@src/styles/color';
import { StyledCountTime, StyledRecordingTime } from './index.style';
import CountTime from './CountTime';

const AudioRecorderStatus = ({
  handleStopRecording,
  recordTime,
  isRecording,
  isCountdown,
  countdown,
  handleReset,
}) => {
  const { t } = useTranslation();

  return (
    <StyledRecordingTime>
      <StyledCountTime>
        <CountTime
          time={formatAudioTime(recordTime)}
          isRecording={isRecording}
          recordSuccess={recordTime >= MIN_DURATION}
        />{' '}
        <span style={{ color: COLOR.colorGrayV2 }}> / </span>{' '}
        <CountTime time={formatAudioTime(MAX_DURATION)} />
      </StyledCountTime>
      {isCountdown ? (
        <Typography variant="body-40-large" color={COLOR.darkBlue}>
          {countdown || ''}
        </Typography>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <CommonButton
            variant="outlineDelete"
            customStyle={{
              width: '48px',
              height: '48px',
              minWidth: '48px',
            }}
            onClick={handleReset}
          >
            <DeleteRoundedIcon />
          </CommonButton>
          <CommonButton
            variant="outlined"
            textProps={{
              variantText: 'body-14-bold',
              color: COLOR.darkBlue,
            }}
            disabled={recordTime < MIN_DURATION}
            onClick={handleStopRecording}
            customStyle={{
              cursor: recordTime < MIN_DURATION ? 'not-allowed' : 'pointer',
              pointerEvents: recordTime < MIN_DURATION ? 'auto' : 'auto',
            }}
          >
            {t('stopRecordingV2')}
          </CommonButton>
        </div>
      )}
    </StyledRecordingTime>
  );
};

export default AudioRecorderStatus;
